/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e="circle",c="sphere";export{e as defaultIconPrimitive,c as defaultObjectPrimitive};
